export default __webpack_public_path__ + "static/media/banner.9d0f06db.mp4";